var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#0E194F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.6C13.849 11.6 13.2247 11.8529 12.7644 12.3029C12.3041 12.753 12.0455 13.3635 12.0455 14C12.0455 14.6365 12.3041 15.247 12.7644 15.6971C13.2247 16.1471 13.849 16.4 14.5 16.4C15.151 16.4 15.7753 16.1471 16.2356 15.6971C16.6959 15.247 16.9545 14.6365 16.9545 14C16.9545 13.3635 16.6959 12.753 16.2356 12.3029C15.7753 11.8529 15.151 11.6 14.5 11.6ZM14.5 18C13.415 18 12.3745 17.5786 11.6073 16.8284C10.8401 16.0783 10.4091 15.0609 10.4091 14C10.4091 12.9391 10.8401 11.9217 11.6073 11.1716C12.3745 10.4214 13.415 10 14.5 10C15.585 10 16.6255 10.4214 17.3927 11.1716C18.1599 11.9217 18.5909 12.9391 18.5909 14C18.5909 15.0609 18.1599 16.0783 17.3927 16.8284C16.6255 17.5786 15.585 18 14.5 18ZM14.5 8C10.4091 8 6.91545 10.488 5.5 14C6.91545 17.512 10.4091 20 14.5 20C18.5909 20 22.0845 17.512 23.5 14C22.0845 10.488 18.5909 8 14.5 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewicon);
export default __webpack_public_path__ + "static/media/viewicon.8254401414c8bec6b66f1b0164d6f929.svg";
export { ForwardRef as ReactComponent };